import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "4f938dba-f5f1-479c-8436-8f84bebbc2c4"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter4f938dbaF5f1479c84368f84bebbc2c4(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter4f938dbaF5f1479c84368f84bebbc2c4 footer`}>
      {props["links"] || <Navigation className="LinksCacbc60bC35c4d299b5a1bc555e6cb87" parentTag={buildClassName("LinksCacbc60bC35c4d299b5a1bc555e6cb87", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo4cd43dd6Ccd64381818002e30971b460" parentTag={buildClassName("Logo4cd43dd6Ccd64381818002e30971b460", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightE37ff017Cafd4222Ad1c0ce7ad492d0c" parentTag={buildClassName("CopyrightE37ff017Cafd4222Ad1c0ce7ad492d0c", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowFd9602ffFe0f483484deC05b5d0c908c" parentTag={buildClassName("GroupflowFd9602ffFe0f483484deC05b5d0c908c", parentTag)} {...props} />}
    </footer>
  );
}

// id: "4cd43dd6-ccd6-4381-8180-02e30971b460"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "4f938dba-f5f1-479c-8436-8f84bebbc2c4"
export function Logo4cd43dd6Ccd64381818002e30971b460(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo4cd43dd6Ccd64381818002e30971b460" parentTag={buildClassName("Logo4cd43dd6Ccd64381818002e30971b460", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "e37ff017-cafd-4222-ad1c-0ce7ad492d0c"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "4f938dba-f5f1-479c-8436-8f84bebbc2c4"
export function CopyrightE37ff017Cafd4222Ad1c0ce7ad492d0c(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightE37ff017Cafd4222Ad1c0ce7ad492d0c" parentTag={buildClassName("CopyrightE37ff017Cafd4222Ad1c0ce7ad492d0c", parentTag)} {...props} />
  );
}

// id: "cacbc60b-c35c-4d29-9b5a-1bc555e6cb87"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "4f938dba-f5f1-479c-8436-8f84bebbc2c4"
export function LinksCacbc60bC35c4d299b5a1bc555e6cb87(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksCacbc60bC35c4d299b5a1bc555e6cb87" parentTag={buildClassName("LinksCacbc60bC35c4d299b5a1bc555e6cb87", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "fd9602ff-fe0f-4834-84de-c05b5d0c908c"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "4f938dba-f5f1-479c-8436-8f84bebbc2c4"
export function GroupflowFd9602ffFe0f483484deC05b5d0c908c(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowFd9602ffFe0f483484deC05b5d0c908c" parentTag={buildClassName("GroupflowFd9602ffFe0f483484deC05b5d0c908c", parentTag)} {...props} />
  );
}

// id: "83dc19d2-3690-4b57-81cd-1a7af3b4a680"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "4cd43dd6-ccd6-4381-8180-02e30971b460"
export const LogoType83dc19d236904b5781cd1a7af3b4a680 = "FOOTER";

// id: "19c592e9-db47-4a96-aa16-02f7a46617bb"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "cacbc60b-c35c-4d29-9b5a-1bc555e6cb87"
export const NavMenuSlug19c592e9Db474a96Aa1602f7a46617bb = "footer-nav";

// id: "743abc3c-fc75-4049-abd7-ff1791707a07"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "4cd43dd6-ccd6-4381-8180-02e30971b460"
export const ContentSlug743abc3cFc754049Abd7Ff1791707a07 = "footer-logo";

const Components = {
  DefaultFooter4f938dbaF5f1479c84368f84bebbc2c4,
  Logo4cd43dd6Ccd64381818002e30971b460,
  CopyrightE37ff017Cafd4222Ad1c0ce7ad492d0c,
  LinksCacbc60bC35c4d299b5a1bc555e6cb87,
  GroupflowFd9602ffFe0f483484deC05b5d0c908c,
  LogoType83dc19d236904b5781cd1a7af3b4a680,
  NavMenuSlug19c592e9Db474a96Aa1602f7a46617bb,
  ContentSlug743abc3cFc754049Abd7Ff1791707a07
}

export default Components;